export default "__VITE_ASSET__BOv6m5KL__"